import React from "react";
import Pagination from "react-bootstrap/Pagination";
import "./index.scss";
import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setRowPerPage, setRowsChange, setNumberOfRecords } from "redux/dashboardReducer";

function PaginationComponent(props) {
  const { pagination, handlePageClick} = props;
  const total_count = useSelector((state) => state.dashboardReducer.tableCount);
  const numberOfRecords = useSelector((state) => state.dashboardReducer.numberOfRecords);
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
//   const [listings, setListings] = useState(5);

  const setRow = (value) => {

    // setListings(value);
    dispatch(setNumberOfRecords(value))
    dispatch(setRowPerPage(value));
    dispatch(setRowsChange(true));
    // handlePageClick("first", value);
  };

  return (
      <>
          <Pagination className="mb-0 d-flex align-items-center border-start justify-content-center justify-content-lg-start">
              {/* <Dropdown show={show}>
            <Dropdown.Toggle onMouseOver={()=>{setShow(true)}} className="bg-white text-black border-0 py-0" id="dropdown-basic">
                <p className="m-0 fs-14px px-2 py-1 mt-1 bg-hover-grey rounded-2 pe-1">
                    {(pagination?.pageNum - 1) * listings + 1} -{''}
                    {total_count > listings ? `${pagination?.pageNum * listings} of ${ pagination?.count * listings}` 
                    : `${pagination?.pageNum} of ${pagination?.count}`}
                 </p>
            </Dropdown.Toggle>
            <Dropdown.Menu onMouseLeave={()=>{setShow(false)}} className="border-0 rounded-0 shadow min-w-100px" >
                <Dropdown.Item className="bg-active-grey fs-14px" onClick={() => setRow(10)}>10 per page</Dropdown.Item>
                <Dropdown.Item className="bg-active-grey fs-14px" onClick={() => setRow(15)}>15 per page</Dropdown.Item>
                <Dropdown.Item className="bg-active-grey fs-14px" onClick={() => setRow(20)}>20 per page</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown> */}
              <div className="btn-hover-dropdown position-relative d-none d-lg-block">
                  <p className="mb-0 fs-14px px-2 py-1 bg-hover-grey rounded-2 pe-1 ms-2 text-center mt-1">
                      {(pagination?.pageNum - 1) * numberOfRecords + 1} - {''}
                      {total_count > numberOfRecords
                          ? `${
                                pagination?.pageNum * numberOfRecords > total_count ? total_count : pagination?.pageNum *numberOfRecords
                            } of ${total_count}`
                          : `${total_count} of ${total_count}`}
                      <div className="border-0 rounded-0 shadow-1 min-w-100px position-absolute bg-white z-index-6 py-2 lh-2 d-none hover-dropdown-menu start-0">
                          <Dropdown.Item
                              className={`bg-active-grey fs-14px py-1 ${
                                numberOfRecords === 5 ? 'bg-light' : ''
                              }`}
                              onClick={() => setRow(5)}
                          >
                              5 per page
                          </Dropdown.Item>
                          <Dropdown.Item
                              className={`bg-active-grey fs-14px py-1 ${
                                numberOfRecords === 10 ? 'bg-light' : ''
                              }`}
                              onClick={() => setRow(10)}
                          >
                              10 per page
                          </Dropdown.Item>
                          <Dropdown.Item
                              className={`bg-active-grey fs-14px py-1 ${
                                numberOfRecords === 15 ? 'bg-light' : ''
                              }`}
                              onClick={() => setRow(15)}
                          >
                              15 per page
                          </Dropdown.Item>
                          <Dropdown.Item
                              className={`bg-active-grey fs-14px py-1 ${
                                numberOfRecords === 20 ? 'bg-light' : ''
                              }`}
                              onClick={() => setRow(20)}
                          >
                              20 per page
                          </Dropdown.Item>
                      </div>
                  </p>
              </div>

              <div>
              <p className="mb-0 fs-14px px-2 py-1 rounded-2 pe-1 ms-2 text-center mt-1 d-lg-none">
                      {(pagination?.pageNum - 1) * numberOfRecords + 1} - {''}
                      {total_count > numberOfRecords
                          ? `${
                                pagination?.pageNum * numberOfRecords > total_count ? total_count : pagination?.pageNum *numberOfRecords
                            } of ${total_count}`
                          : `${total_count} of ${total_count}`}
                  </p>
              </div>

              <div className="d-flex align-items-center mx-2">
                  <Pagination.First
                       className={`btn-padding-reset ${
                        pagination?.pageNum > 1 ? '' : 'pagination-disabled'
                    }`}
                  >
                      <button
                      onClick={() => handlePageClick('first')}
                          disabled={pagination?.pageNum > 1 ? 0 : 1}
                          className={`p-0 fs-18px h-30px w-30px rounded-circle  d-flex align-items-center justify-content-center me-1 border-0 btn bg-active-grey ${
                              pagination.pageNum > 1
                                  ? 'bg-hover-grey cursor-pointer'
                                  : ''
                          }`}
                      >
                          <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="6"
                              height="12"
                              viewBox="0 0 6 12"
                          >
                              <path
                                  id="Path_54090"
                                  data-name="Path 54090"
                                  d="M5.181,5.85a.727.727,0,0,1-.513-.21L.213,1.227A.714.714,0,0,1,.213.21a.731.731,0,0,1,1.026,0l3.942,3.9L9.123.211a.731.731,0,0,1,1.026,0,.713.713,0,0,1,0,1.016L5.694,5.639A.727.727,0,0,1,5.181,5.85Z"
                                  transform="translate(5.85) rotate(90)"
                                  fill={`${
                                      pagination?.pageNum > 1
                                          ? '#29323C'
                                          : '#6c757d'
                                  }`}
                              />
                          </svg>
                          <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="6"
                              height="12"
                              viewBox="0 0 6 12"
                          >
                              <path
                                  id="Path_54090"
                                  data-name="Path 54090"
                                  d="M5.181,5.85a.727.727,0,0,1-.513-.21L.213,1.227A.714.714,0,0,1,.213.21a.731.731,0,0,1,1.026,0l3.942,3.9L9.123.211a.731.731,0,0,1,1.026,0,.713.713,0,0,1,0,1.016L5.694,5.639A.727.727,0,0,1,5.181,5.85Z"
                                  transform="translate(5.85) rotate(90)"
                                  fill={`${
                                      pagination?.pageNum > 1
                                          ? '#29323C'
                                          : '#6c757d'
                                  }`}
                              />
                          </svg>
                      </button>
                  </Pagination.First>
                  <Pagination.Prev
                      className={`btn-padding-reset ${
                          pagination?.pageNum > 1 ? '' : 'pagination-disabled'
                      }`}
                  >
                      <button
                          disabled={pagination?.pageNum > 1 ? 0 : 1}
                          className={`p-0 fs-18px h-30px w-30px rounded-circle  d-flex align-items-center justify-content-center me-1 border-0 btn bg-active-grey ${
                              pagination.pageNum > 1
                                  ? 'bg-hover-grey cursor-pointer'
                                  : ''
                          }`}
                          onClick={() => handlePageClick('prev')}
                      >
                          <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="6"
                              height="12"
                              viewBox="0 0 6 12"
                          >
                              <path
                                  id="Path_54090"
                                  data-name="Path 54090"
                                  d="M5.181,5.85a.727.727,0,0,1-.513-.21L.213,1.227A.714.714,0,0,1,.213.21a.731.731,0,0,1,1.026,0l3.942,3.9L9.123.211a.731.731,0,0,1,1.026,0,.713.713,0,0,1,0,1.016L5.694,5.639A.727.727,0,0,1,5.181,5.85Z"
                                  transform="translate(5.85) rotate(90)"
                                  fill={`${
                                      pagination?.pageNum > 1
                                          ? '#29323C'
                                          : '#6c757d'
                                  }`}
                              />
                          </svg>
                      </button>
                      <Pagination.Item></Pagination.Item>
                  </Pagination.Prev>
                  <Pagination.Next
                      className={`btn-padding-reset ${
                          pagination?.pageNum === pagination?.count
                              ? 'pagination-disabled'
                              : ''
                      }`}
                  >
                      <button
                          disabled={pagination?.pageNum === pagination?.count}
                          className={`p-0 fs-18px h-30px w-30px rounded-circle  d-flex align-items-center justify-content-center me-1 border-0 btn bg-active-grey ${
                              pagination?.pageNum === pagination?.count
                                  ? ''
                                  : 'bg-hover-grey cursor-pointer'
                          }`}
                          onClick={() => handlePageClick('next')}
                      >
                          <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="6"
                              height="12"
                              viewBox="0 0 6 12"
                          >
                              <path
                                  id="Path_53944"
                                  data-name="Path 53944"
                                  d="M5.181,0a.727.727,0,0,0-.513.21L.213,4.623a.714.714,0,0,0,0,1.016.731.731,0,0,0,1.026,0l3.942-3.9,3.942,3.9a.731.731,0,0,0,1.026,0,.713.713,0,0,0,0-1.016L5.694.21A.727.727,0,0,0,5.181,0Z"
                                  transform="translate(5.85) rotate(90)"
                                  fill={`${
                                      pagination?.pageNum === pagination?.count
                                          ? '#6c757d'
                                          : '#29323C'
                                  }`}
                              />
                          </svg>
                      </button>
                  </Pagination.Next>
                  <Pagination.Last
                      className={`btn-padding-reset ${
                          pagination?.pageNum === pagination?.count
                              ? 'pagination-disabled'
                              : ''
                      }`}
                  >
                      <button  onClick={() => handlePageClick('last')}
                          disabled={pagination?.pageNum === pagination?.count}
                          className={`p-0 fs-18px h-30px w-30px rounded-circle  d-flex align-items-center justify-content-center me-1 border-0 btn bg-active-grey ${
                              pagination?.pageNum === pagination?.count
                                  ? ''
                                  : 'bg-hover-grey cursor-pointer'
                          }`}
                      >
                          <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="6"
                              height="12"
                              viewBox="0 0 6 12"
                          >
                              <path
                                  id="Path_53944"
                                  data-name="Path 53944"
                                  d="M5.181,0a.727.727,0,0,0-.513.21L.213,4.623a.714.714,0,0,0,0,1.016.731.731,0,0,0,1.026,0l3.942-3.9,3.942,3.9a.731.731,0,0,0,1.026,0,.713.713,0,0,0,0-1.016L5.694.21A.727.727,0,0,0,5.181,0Z"
                                  transform="translate(5.85) rotate(90)"
                                  fill={`${
                                      pagination?.pageNum === pagination?.count
                                          ? '#6c757d'
                                          : '#29323C'
                                  }`}
                              />
                          </svg>
                          <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="6"
                              height="12"
                              viewBox="0 0 6 12"
                          >
                              <path
                                  id="Path_53944"
                                  data-name="Path 53944"
                                  d="M5.181,0a.727.727,0,0,0-.513.21L.213,4.623a.714.714,0,0,0,0,1.016.731.731,0,0,0,1.026,0l3.942-3.9,3.942,3.9a.731.731,0,0,0,1.026,0,.713.713,0,0,0,0-1.016L5.694.21A.727.727,0,0,0,5.181,0Z"
                                  transform="translate(5.85) rotate(90)"
                                  fill={`${
                                      pagination?.pageNum === pagination?.count
                                          ? '#6c757d'
                                          : '#29323C'
                                  }`}
                              />
                          </svg>
                      </button>
                  </Pagination.Last>
              </div>
          </Pagination>
      </>
  );
}

export default PaginationComponent;
